// Shimmed to the shared @owlcat/ui baseline (identical-by-default, forkable).
export {
  Dialog,
  DialogPortal,
  DialogOverlay,
  DialogTrigger,
  DialogClose,
  DialogContent,
  DialogHeader,
  DialogFooter,
  DialogTitle,
  DialogDescription,
} from "@owlcat/ui"
